import React from 'react';
import i18n from '../utils/i18n';
import Layout from '../components/Layout/Layout';
import BookmarksPage from '../components/Views/BookmarksPage';
import { getSeoData } from '../utils/helpers';

const Bookmarks = () => <BookmarksPage />;

Bookmarks.getInitialProps = async ({ apolloClient, asPath, req }) => {
  const seoData = await getSeoData(apolloClient, asPath, req);

  return {
    seoData
  };
};

Bookmarks.getLayout = function getLayout(page) {
  return <Layout headerTitle={i18n.t('pages.bookmarks.title')}>{page}</Layout>;
};

export default Bookmarks;
